import styled from 'styled-components';

export const StepField = styled.div`
  width: 220px;
`;

export const FieldInfo = styled.span`
  margin-top: 4px;

  font-size: ${props => props.theme.sizeExtraSmall};
  color: ${props => props.theme.gray85};
`;
